'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var prodTopicListId = exports.prodTopicListId = {
  '轉型正義': '57ac8151363d1610007ef656',
  '0206地震': '57ac8161363d1610007ef657',
  '亞洲森林浩劫': '57ac816f363d1610007ef658',
  '走入同志家庭': '57ac8177363d1610007ef659',
  '急診人生': '57ac8180363d1610007ef65a',
  '測試專題': '579c46896fa30f1827587056',
  '五輕關廠': '57ac8192363d1610007ef65b'
};
var devTopicListId = exports.devTopicListId = {
  '轉型正義': '579f01eca825a25a31eabc19',
  '0206地震': '579f01ffa825a25a31eabc1a',
  '亞洲森林浩劫': '579f0211a825a25a31eabc1b',
  '走入同志家庭': '579f0224a825a25a31eabc1c',
  '急診人生': '579f022fa825a25a31eabc1d',
  '測試專題': '579c4301411c987224380ad2',
  '五輕關廠': '57ab381936b7f2b2458e3bcf'
};

var prodCatListId = exports.prodCatListId = {
  '台灣': '5743d323940ee41000e81f48',
  '媒體': '5743d34a940ee41000e81f49',
  '國際': '5743d35a940ee41000e81f4a',
  '文化': '57175d923970a5e46ff854db',
  '專題': '573177d88c0c261000b3f6d3',
  '評論': '573177cb8c0c261000b3f6d2',
  '影像': '574d028748fa171000c45d48'
};
var devCatListId = exports.devCatListId = {
  '台灣': '5743d323940ee41000e81f48',
  '媒體': '5743d34a940ee41000e81f49',
  '國際': '5743d35a940ee41000e81f4a',
  '文化': '57175d923970a5e46ff854db',
  '專題': '573177d88c0c261000b3f6d3',
  '評論': '573177cb8c0c261000b3f6d2',
  '影像': '57ac98b436b7f2b2458e3bd0'
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/conf/list-id.js
 ** module id = 333
 ** module chunks = 0
 **/